module.exports = __webpack_public_path__ + "img/13.b76b2abe.jpg";